import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createSelector } from "@reduxjs/toolkit";

interface PortState {
  loading: boolean;
  port: Port | null;
}

interface Port {
  id: string;
  name: string;
  wharves: Wharf[];
  center: {
    latitude: number;
    longitude: number;
  };
  zoomLevel: number;
  mapTmsUrl: string;
}

interface Wharf {
  id: string;
  name: string;
}

const initialState: PortState = {
  port: null,
  loading: false,
};

const portSlice = createSlice({
  name: "port",
  initialState,
  reducers: {
    setPort: (state, action: PayloadAction<Port>) => {
      state.port = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setPort, setLoading } = portSlice.actions;
export default portSlice.reducer;

interface RootState {
  port: PortState;
}

export function selectPortState(state: RootState): PortState {
  return state.port;
}
export const selectPort = createSelector(
  selectPortState,
  (portState) => portState.port,
);
export const selectPortName = createSelector(
  selectPort,
  (port) => port?.name ?? null,
);
export const selectWharves = createSelector(
  selectPort,
  (port) => port?.wharves ?? [],
);
